<template>
  <div class="pop">
    <div class="box">
      <div class="top">{{type==1?"分类添加":"分类编辑"}}</div>
      <div class="center">
        <div class="item">
          <span>分类名称：</span>
          <span>
            <i-input style="width:250px" v-model="data.qbtitle" placeholder="请输入分类名称"></i-input>
          </span>
        </div>
        <div class="item">
          <span>分类描述：</span>
          <span>
            <i-input style="width:250px" type="textarea" v-model="data.qbdescrip" placeholder="请输入分类描述"></i-input>
          </span>
        </div>
      </div>
      <div class="bottom">
        <Button style="margin-right:100px" @click="close">取消</Button>
        <Button type="primary" @click="act">确定</Button>
      </div>
    </div>
  </div>
</template>
<script>
import { QuestionBasic_add,QuestionBasic_getInfo,QuestionBasic_update } from "../../assets/js/api.js";
export default {
  data() {
    return {
      data: {
        qbtitle:null,//	string	true	普通参数		用户组
        qbdescrip:null,//	string	true	普通参数		描述
      }
    };
  },
  props: ["type", "dataset"],
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (this.type == 2) {
       QuestionBasic_getInfo({ qbid: this.dataset }).then(res => {
            if(res.data.code==200){
                this.data = res.data.data;
                // delete this.data.qbpid
                return
            }
               this.$Notice.warning({ title: "信息提示", desc: res.data.message });
        });
      }
    },
    close() {
      this.$emit("close");
    },
    act() {
      if (this.type == 1) this.add();
      if (this.type == 2) this.updated();
    },
    add() {
      this.data.qbpid = this.dataset
      QuestionBasic_add(this.data).then(res => {
        if (res.data.code == 200) {
           this.$Notice.success({ title: '成功提示',desc:'添加成功！'});
          this.$emit("success");
          return;
        }
           this.$Notice.warning({ title: "信息提示", desc: res.data.message });;
      });
    },
    updated() {
      this.data.qbid = this.dataset
      QuestionBasic_update (this.data).then(res => {
        if (res.data.code == 200) {
           this.$Notice.success({ title: '成功提示',desc:'编辑成功！'});
          this.$emit("success");
          return;
        }
           this.$Notice.warning({ title: "信息提示", desc: res.data.message });;
      });
    }
  }
};
</script>
<style lang="css" scoped>
.pop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
}
.box {
  width: 400px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 10px;
}
.top {
  height: 50px;
  line-height: 50px;
  color: #fff;
  font-size: 18px;
  border-bottom: 1px solid #bbb;
  background: rgb(60, 91, 230);
  border-radius: 10px 10px 0 0;
  text-align: left;
  padding-left: 2em;
}
.item {
  margin-top: 20px;
}
/* .item span:first-child {
  display: inline-block;
  width: 100px;
  text-align: right;
} */
.bottom {
  margin: 20px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/toast/classmanage.vue